<script setup lang="ts">
  import { onBeforeMount, ref } from 'vue';

  import type { SMSTemplateVariable } from '@stuut/api-sdk/models';
  import { Button } from '@ui/components/button';
  import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
  } from '@ui/components/dropdown-menu';

  import { sdk } from '@/sdk';

  const emits = defineEmits<{
    (e: 'variableSelected', variable: SMSTemplateVariable): void;
  }>();

  const isLoading = ref(false);
  const variables = ref<SMSTemplateVariable[]>([]);

  onBeforeMount(() => {
    isLoading.value = true;

    sdk.smsTemplates
      .listVariables()
      .then((result) => {
        variables.value = result;
      })
      .catch((err) => {
        console.error('Failed to load SMS template variables:', err);
      })
      .finally(() => (isLoading.value = false));
  });
</script>

<template>
  <DropdownMenu>
    <DropdownMenuTrigger as-child>
      <Button class="w-fit!" size="sm" variant="secondary" :outline="true" :disabled="isLoading">
        <!-- TODO Remove hardcoded when fixing auto icon in button.index -->
        <i class="fa-regular fa-bolt"></i>
        <span>Variable</span>
      </Button>
    </DropdownMenuTrigger>

    <DropdownMenuContent class="h-fit! max-h-[300px] overflow-y-auto">
      <DropdownMenuItem
        v-for="variable in variables"
        :key="variable.name"
        :value="variable.name"
        @click="emits('variableSelected', variable)"
      >
        {{ variable.displayName }}
      </DropdownMenuItem>

      <div v-if="!variables.length && !isLoading" class="px-2 py-1.5 text-sm text-muted-foreground">
        No variables available
      </div>
    </DropdownMenuContent>
  </DropdownMenu>
</template>
